import { riverIceLegend } from '../config/legends'

const service =  {
    name: 'RiverIce',
    label: 'River Ice',
    iconComponent: 'RiverIce',
    hideDatetimeSlider: true,
    weather: true,
    disableMainDate: true,
    minTime: new Date(2018, 0, 1).toISOString(),
    maxTime: new Date(2020, 0, 1).toISOString(),
    data: [
      {
        id: 'RiverIcePoint',
        url: `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3ARiverIceAreaNormalized`,
        datetimeId: 'RiverIce',
        type: 'extent',
        active: 'RiverIcePointActive'
      },
      {
        id: 'RiverIce',
        url: `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3ARiverIceAreaNormalizedMV`,
        datetimeId: 'RiverIce',
        type: 'extent',
        active: 'active'
      }
    ],
    datetimeUrls: [
      {
        id: 'RiverIce',
        url:
          'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:RiverIceAreaBounds&maxFeatures=500&outputFormat=application%2Fjson'
      }
    ],
    layers: [
      {
        name: 'RiverIce',
        label: 'Ice classification',
        opacity: 'fill-opacity',
        datetimeId: 'RiverIce',
        open: true,
        // datetimeTransform: 'utcDatetime',
        legend: {
          type: 'categorical',
          data: riverIceLegend
        }
      },
      // {
      //   name: 'Sentinel2Transparent',
      //   label: 'Sentinel 2',
      //   url: RIVER_ICE,
      //   opacity: 'raster-opacity',
      //   datetimeId: 'Sentinel2'
      // },
      {
        name: 'RiverIceMarkers',
        label: 'Kilometre markers',
        opacity: 'line-opacity'
      }
    ],
    locations: [
      {
        name: 'Athabasca River',
        extent: [[54.65, -114.2], [57.23, -111.08]],
        latitude: 55.73,
        longitude: -112.38,
        zoom: [7],
        maxBounds: [[-140.5, 53], [-110.0, 58]]
      },
      // {
      //   name: 'Churchill River',
      //   extent: [[54.65, -114.2], [57.23, -111.08]],
      //   latitude: 53.35,
      //   longitude: -60.18,
      //   zoom: [7],
      //   maxBounds: [[-80, 51], [-55, 68]]
      // }
    ]
}

export default service



// WEBPACK FOOTER //
// ./src/services/RiverIce.js